<template>
  <div class="content-box">
    <div class="columns is-mobile">
      <div class="column is-narrow p-l-10 p-r-0 is-flex-centered">
        <IconView
          v-if="icon"
          pack="cls"
          size="is-small"
          :custom-class="`cls-${icon} ${iconClasses}`"
        />
        <slot name="icon" v-else />
      </div>
      <div class="column">
        <p class="is-pulled-left dropdown-item-label">{{ label }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import IconView from '@/modules/core/ui/components/wrappers/IconView.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'DropdownItemContent',
  slotsDefinition: {
    icon: {}
  },
  components: { IconView },
  props: {
    label: { type: String, required: true },
    icon: { type: String },
    iconClasses: { type: String, default: '' }
  }
};
</script>
